import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { IProductsTable } from './interface';
import Table from '..';
import { IBatchRequestResponse } from 'models/Batch';
import { IProductsData, ICategory } from 'models/Product';
import KeycloakPubServiceInstance from 'services/keycloakpubsub.service';
import ProductServices from 'services/product.service';
import ProductsTableSearch from './Search';
import { Row, Column } from 'components/Layout/Grid';
import { Button } from 'components/Button';
import { useSelector } from 'react-redux';
import { RootState } from 'store/ducks';

const ProductsTable: React.FC<IProductsTable> = (props) => {
  const { model, completeBlankSpaces, showCards, className, isEditing, protocolCategory } = props;

  const [showTable, setShowTable] = useState(false);

  const [tableFilter, setTableFilter] = useState<any>();
  const [products, setProducts] = useState<
    IBatchRequestResponse<IProductsData>
  >();
  const [categories, setCategories] = useState<Array<ICategory>>();
  const [tableOrderBy, setTableOrderBy] = useState('code desc');
  const [currentPage, setCurrentPage] = useState(0);

  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedSubCategory, setSelectedSubCategory] = useState('');

  // eslint-disable-next-line react/destructuring-assignment
  const pageTotal = props.pageSize || 10;

  const productSelected = useSelector(
    (state: RootState) => state.openProtocolData.products
  );

  const getProducts = useCallback(() => {
    const productService = new ProductServices();

    setCategories(undefined);
    setProducts(undefined);

    const filterData: any = {
      and: {},
    };

    let filterProduct: any = { ...tableFilter };

    if (isEditing && productSelected?.length > 0) {

      filterData.and = {
        ...filterData.and,
        'tolower(code)': { eq: productSelected[0]?.code?.toLowerCase() }
      };

      filterProduct = { ...filterData };

      if (tableFilter && Object.keys(tableFilter.and).length > 0) {
        filterProduct = { ...tableFilter };
      }
    }

    productService
      .get(currentPage, pageTotal, tableOrderBy, filterProduct)
      .then((result: IBatchRequestResponse<IProductsData> | undefined) => {
        if (result) {
          const { error, data, totalPages, pageSize, total } = result;
          setProducts({ error, data, totalPages, pageSize, total });
        }
      });
  }, [currentPage, tableFilter, tableOrderBy]);

  const ProductTable = useMemo(
    () => (
      <Table
        trackingKey="Grid Produtos"
        className="mt-2"
        error={products?.error}
        onReload={getProducts}
        setTableOrder={setTableOrderBy}
        tableOrder={tableOrderBy}
        currentPage={currentPage}
        data={products?.data}
        pageSize={pageTotal}
        onPageChange={setCurrentPage}
        totalPages={products?.totalPages}
        model={model}
        completeBlankSpaces={completeBlankSpaces || false}
      />
    ),
    [products]
  );

  useEffect(() => {
    KeycloakPubServiceInstance.subscribe(() => {
      getProducts();
    });
  }, [getProducts, protocolCategory]);

  function setCategory(categoryKey: string) {
    setShowTable(true);
    setSelectedCategory(categoryKey);
  }

  function setSubCategory(categoryKey: string, subCategoryKey: string) {
    setShowTable(true);
    setSelectedCategory(categoryKey);
    setSelectedSubCategory(subCategoryKey);
  }

  return (
    <>
      <ProductsTableSearch
        setTableFilter={setTableFilter}
        setCurrentPage={setCurrentPage}
        setShowTable={setShowTable}
        categoryFilters={categories}
        selectedCategory={selectedCategory}
        selectedSubCategory={selectedSubCategory}
        className={className}
      />
      {showTable || (showCards !== undefined && !showCards) ? (
        ProductTable
      ) : (
        <Row className="bg-white flex-wrap px-3 pb-3">
          {categories?.map((category, index) => (
            <Column className="w-50 pt-3" key={index}>
              <Row>
                <Button
                  onClick={() => setCategory(category._mockKey)}
                  className="color-blue-gray font-bold"
                >
                  {category.name}
                </Button>
              </Row>
              <Row className="flex-wrap">
                {category.subOptions?.map((subCategory, indexSub) => (
                  <Button
                    key={indexSub}
                    onClick={() =>
                      setSubCategory(category._mockKey, subCategory._mockKey)
                    }
                    className="bg-gray color-dark-gray w-30 mt-2 mr-2 pt-2 pb-2 text-center"
                  >
                    {subCategory.name}
                  </Button>
                ))}
              </Row>
            </Column>
          ))}
        </Row>
      )}
    </>
  );
};

export default ProductsTable;
